import { GetLoans } from "../../services/modules/loan";
import { useFetch } from "./config";
import { isReactSnap } from "../../utils/react-snap";

export function useFetchLoans() {
  return useFetch({
    queryKeys: ["loans"],
    queryFn: async () => {
      const { resultData } = await GetLoans();
      return resultData;
    },
    enabled: !isReactSnap(),
  });
}
